import React, { createContext, useContext, useState, ReactNode } from 'react';
import { TransactionModal } from '../components/administracion/TransactionModal';
import type { TipoOperacion } from '../types/administracion';

interface ModalContextType {
  openModal: (tipo: TipoOperacion) => void;
  closeModal: () => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};

interface ModalProviderProps {
  children: ReactNode;
}

export const ModalProvider: React.FC<ModalProviderProps> = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState<TipoOperacion>('GASTO');

  const openModal = (tipo: TipoOperacion) => {
    setModalType(tipo);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleModalSuccess = () => {
    // For global modal, just close it. Pages can refresh if needed.
    closeModal();
  };

  return (
    <ModalContext.Provider value={{ openModal, closeModal }}>
      {children}
      <TransactionModal
        isOpen={isModalOpen}
        onClose={closeModal}
        tipoOperacionInicial={modalType}
        onSuccess={handleModalSuccess}
      />
    </ModalContext.Provider>
  );
};